import getActionsByDocument from '../../../../../components/logs/actions';

const DOCUMENT = 'CLIENT_LOGS_';

export default getActionsByDocument(DOCUMENT);
